import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import { setBannerIsOpen } from 'store/AppState/actions'
import { getBannerIsOpen } from 'store/AppState/selector'
import { ReactComponent as IconClose } from 'assets/icons/IconCloseSm.svg'

const Banner = ({ bannerSettings, children }) => {
  const { text, linkText } = bannerSettings

  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const isBannerOpen = useSelector((state) =>
    getBannerIsOpen(state, pathname.replace('/', ''))
  )

  const onClose = () => {
    dispatch(setBannerIsOpen({ [pathname.replace('/', '')]: false }))
  }

  return (
    <>
      {isBannerOpen && (
        <div className="banner">
          <p className="banner__text">{text}</p>
          <a
            className="banner__link"
            href="https://support.venuenext.net/hc/en-us/articles/9773070360211-Managing-Display-Categories"
          >
            {linkText}
          </a>
          <button className="banner__close-icon" onClick={onClose}>
            <IconClose width="14" height="14" />
          </button>
        </div>
      )}

      {children}
    </>
  )
}

export default Banner
